<template>
  <div class="company_detai appContainer" v-if="viewPage">
    <div class="title_wrapper">
      <div class="title-company-detail">
        <div class="line"></div>
        <h1>
          {{
            companyInfoDetail !== null &&
            companyInfoDetail.company_name !== null
              ? companyInfoDetail.company_name
              : ''
          }}
        </h1>
      </div>

      <v-btn
        color="#42a2ff"
        rounded
        class="fav_btn"
        v-if="favoriteStatus === false && detailStatus"
        @click="
          actionToFavorite(
            companyDetail !== null && companyDetail.companyInfo !== null
              ? companyDetail.companyInfo.id
              : null
          )
        "
      >
        <img src="@/assets/image/star.svg" alt />
        <span class="fav_btn_info">{{
          $t('company-detail.button-add-to-favorite-company', {
            split: '/'
          })
        }}</span>
      </v-btn>

      <v-btn
        v-else-if="favoriteStatus === true && detailStatus"
        color="#E8320D"
        rounded
        class="fav_btn"
        @click="
          actionToFavorite(
            companyDetail !== null && companyDetail.companyInfo !== null
              ? companyDetail.companyInfo.id
              : null
          )
        "
      >
        <img src="@/assets/image/star.svg" alt />
        <span class="fav_btn_info">{{
          $t('company-detail.button-remove-from-favorite-company', {
            split: '/'
          })
        }}</span>
      </v-btn>
    </div>

    <InformationOfCompany
      :companyDetail="companyDetail"
      :companyInfoDetail="companyInfoDetail"
    />

    <TabsOfCompany
      v-if="companyDetail !== null"
      :dataJobDescription="dataJobDescription"
      :dataCompanyCareerFromDetail="dataCompanyCareerFromDetail"
      :dataCompanyPrFromDetail="dataCompanyPrFromDetail"
    />

    <v-row>
      <v-col
        cols="12"
        md="4"
        lg="4"
        sm="4"
        v-if="
          companyDetail !== null &&
          companyDetail.detail.d_company !== null &&
          companyDetail.detail.d_company.promotion_img_1 !== null
        "
      >
        <v-card class="mx-auto" max-width="400">
          <v-img
            class="white--text align-end"
            :src="
              companyDetail !== null &&
              companyDetail.detail.d_company !== null &&
              companyDetail.detail.d_company.promotion_img_1 !== null
                ? companyDetail.detail.d_company.promotion_img_1
                : ''
            "
          >
          </v-img>
        </v-card>
      </v-col>

      <v-col
        cols="12"
        md="4"
        lg="4"
        sm="4"
        v-if="
          companyDetail !== null &&
          companyDetail.detail.d_company !== null &&
          companyDetail.detail.d_company.promotion_img_2 !== null
        "
      >
        <v-card class="mx-auto" max-width="400">
          <v-img
            class="white--text align-end"
            :src="
              companyDetail !== null &&
              companyDetail.detail.d_company !== null &&
              companyDetail.detail.d_company.promotion_img_2 !== null
                ? companyDetail.detail.d_company.promotion_img_2
                : ''
            "
          >
          </v-img>
        </v-card>
      </v-col>

      <v-col
        cols="12"
        md="4"
        lg="4"
        sm="4"
        v-if="
          companyDetail !== null &&
          companyDetail.detail.d_company !== null &&
          companyDetail.detail.d_company.promotion_img_3 !== null
        "
      >
        <v-card class="mx-auto" max-width="400">
          <v-img
            class="white--text align-end"
            :src="
              companyDetail !== null &&
              companyDetail.detail.d_company !== null &&
              companyDetail.detail.d_company.promotion_img_3 !== null
                ? companyDetail.detail.d_company.promotion_img_3
                : ''
            "
          >
          </v-img>
        </v-card>
      </v-col>
    </v-row>
    <div
      id="interview-scroll"
      class="interview"
      v-if="checkInterviewSchedule()"
    >
      <h2 class="left-border">
        {{ $t('company-detail.interview-schedule', { split: '/' }) }}
      </h2>
      <p
        class="event-interview-note"
        v-if="eventInterviewNote && this.$i18n.locale === LANG_CODE_JAPANESE"
      >
        {{ eventInterviewNote.interview_note }}
      </p>
      <p
        class="event-interview-note"
        v-if="eventInterviewNote && this.$i18n.locale === LANG_CODE_VIETNAMESE"
      >
        {{ eventInterviewNote.interview_note_vn }}
      </p>
      <p class="company-interview-note-title" v-if="companyInterviewNote">
        {{ $t('company-detail.company-interview-note-title', { split: '/' }) }}
      </p>
      <p
        class="company-interview-note"
        v-if="
          companyInterviewNote && this.$i18n.locale === LANG_CODE_VIETNAMESE
        "
      >
        {{ companyInterviewNote.note_vn }}
      </p>
      <p
        class="company-interview-note"
        v-if="companyInterviewNote && this.$i18n.locale === LANG_CODE_JAPANESE"
      >
        {{ companyInterviewNote.note }}
      </p>
      <v-data-table
        :headers="headers"
        :items="
          applicantCompanyInterview !== null &&
          typeof applicantCompanyInterview !== 'undefined' &&
          applicantCompanyInterview.length !== 0
            ? applicantCompanyInterview
            : []
        "
        hide-default-footer
        disable-pagination
        class="elevation-1 app_table"
      >
        <template v-slot:item.date="{ item }">
          {{ formatDate(item.date) }}
        </template>
        <template v-slot:item.applicant_sum="{ item }">
          {{
            item.applicant_apply_sum +
            ' / ' +
            (item.limit !== null && item.limit > 0
              ? item.limit
              : $t('company-detail.no-limit', { split: '/' }))
          }}
        </template>

        <template v-slot:item.button="{ item }">
          <v-btn
            @click="
              handleShowConfirmationApply(
                item.exhibiting_company_id,
                item.interview_schedule_id,
                0
              )
            "
            color="#E8320D"
            class="status_interview_btn"
            dark
            v-if="item.button == 1"
          >
            {{ $t(item.text) }}
          </v-btn>
          <v-btn
            @click="
              handleShowConfirmationCancel(
                item.exhibiting_company_id,
                item.interview_schedule_id,
                9
              )
            "
            color="#9e9e9e"
            class="status_interview_btn"
            dark
            v-if="item.button == 2"
          >
            {{ $t(item.text) }}
          </v-btn>
          <div v-if="item.button == 0">
            {{ $t(item.text) }}
          </div>
        </template>
        <template v-slot:item.status="{ item }">
          {{ $t(item.status) }}
        </template>
      </v-data-table>
    </div>
    <v-dialog v-model="confirmationApply" max-width="520">
      <v-card class="dialog-container">
        <div class="dialog">
          <h4 v-html="$t('company-detail.confirmation-popup.applying')"></h4>
          <v-card-actions>
            <v-btn
              class="btn-logout"
              depressed
              color="#e8320e"
              @click="applyOrCancelInterview"
              :loading="btnLoading"
            >
              {{ $t('company-detail.confirmation-popup.yes') }}
            </v-btn>

            <v-btn
              id="btnCloseApplyConfirm"
              @click="handleCloseConfirmationApply"
              outlined
              color="#e8320e"
            >
              {{ $t('company-detail.confirmation-popup.no') }}
            </v-btn>
          </v-card-actions>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="confirmationCancel" max-width="520">
      <v-card class="dialog-container">
        <div class="dialog">
          <h4 v-html="$t('company-detail.confirmation-popup.cancel')"></h4>
          <v-card-actions>
            <v-btn
              class="btn-logout"
              depressed
              color="#e8320e"
              @click="applyOrCancelInterview"
              :loading="btnLoading"
            >
              {{ $t('company-detail.confirmation-popup.yes') }}
            </v-btn>

            <v-btn
              id="btnCloseCancelConfirm"
              @click="handleCloseConfirmationCancel"
              outlined
              color="#e8320e"
            >
              {{ $t('company-detail.confirmation-popup.no') }}
            </v-btn>
          </v-card-actions>
        </div>
      </v-card>
    </v-dialog>
    <div id="bottom-page"></div>
    <ScrollBottomBtn />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ScrollBottomBtn from '@/components/ScrollBottomBtn';
import InformationOfCompany from '@/components/entry/InformationOfCompany';
import TabsOfCompany from '@/components/entry/TabsOfCompany';
import moment from 'moment-timezone';
import {
  DISPLAY_INTERVIEW_SCHEDULE,
  UNDISPLAY_INTERVIEW_SCHEDULE
} from '@/common/constants';
export default {
  components: {
    ScrollBottomBtn,
    InformationOfCompany,
    TabsOfCompany
  },
  data() {
    return {
      favoriteStatus: 'like',

      headers: [
        {
          text: this.$t('company-detail.header-table.date', {
            split: '/'
          }),
          sortable: false,
          value: 'date'
        },
        {
          text: this.$t('company-detail.header-table.time', {
            split: '/'
          }),
          sortable: false,
          value: 'time'
        },
        {
          text: this.$t('company-detail.header-table.applicant_sum', {
            split: '/'
          }),
          sortable: false,
          value: 'applicant_sum'
        },
        {
          text: this.$t('company-detail.header-table.status', {
            split: '/'
          }),
          sortable: false,
          value: 'status'
        },
        {
          text: this.$t('company-detail.header-table.detail', {
            split: '/'
          }),
          sortable: false,
          value: 'button'
        }
      ],
      viewPage: true,
      detailStatus: true,
      confirmationApply: false,
      confirmationCancel: false,
      exhibitingCompanyId: null,
      interviewScheduleId: null,
      interviewStatus: null,
      btnLoading: false
    };
  },

  methods: {
    getDateFromUTC() {
      const timeZoneFilter = this.c_time_zone.filter(
        (timezone) => timezone.id == this.m_event.time_zone
      );

      if (timeZoneFilter.length > 0) {
        return moment(new Date())
          .tz(timeZoneFilter[0].time_zone_code)
          .format('YYYY-MM-DD');
      }
    },
    getDateTimeFromUTC() {
      const timeZoneFilter = this.c_time_zone.filter(
        (timezone) => timezone.id == this.m_event.time_zone
      );

      if (timeZoneFilter.length > 0) {
        return moment(new Date())
          .tz(timeZoneFilter[0].time_zone_code)
          .format('YYYY-MM-DD HH:mm:ss');
      }
    },
    checkDisplayListCompany(fromData, toData) {
      const timeZoneFilter = this.c_time_zone.filter(
        (timezone) => timezone.id == this.m_event.time_zone
      );

      if (timeZoneFilter.length > 0) {
        const dateFrom = moment
          .utc(fromData)
          .tz(timeZoneFilter[0].time_zone_code)
          .format('YYYY-MM-DD HH:mm:ss');

        const dateTo = moment
          .utc(toData)
          .tz(timeZoneFilter[0].time_zone_code)
          .format('YYYY-MM-DD HH:mm:ss');

        const now = this.getDateTimeFromUTC();

        if (now < dateFrom || now > dateTo) {
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    },
    checkRoute() {
      switch (this.$route.name) {
        case 'company-detail':
          const checkCompanyDisplay = this.checkListCompanyDisplay;
          if (!checkCompanyDisplay) {
            this.$router.replace({ name: 'list-company' }, () => {});
          }
          break;
      }
    },
    actionToFavorite(exhibiting_company_id) {
      if (exhibiting_company_id !== null) {
        this.$store.dispatch('actionToFavorite', {
          exhibiting_company_id
        });
      }
    },
    handleShowConfirmationApply(
      exhibiting_company_id,
      interview_schedule_id,
      interview_status
    ) {
      this.confirmationApply = true;
      this.exhibitingCompanyId = exhibiting_company_id;
      this.interviewScheduleId = interview_schedule_id;
      this.interviewStatus = interview_status;
    },
    handleCloseConfirmationApply() {
      this.confirmationApply = false;
      this.exhibitingCompanyId = null;
      this.interviewScheduleId = null;
      this.interviewStatus = null;
    },
    handleShowConfirmationCancel(
      exhibiting_company_id,
      interview_schedule_id,
      interview_status
    ) {
      this.confirmationCancel = true;
      this.exhibitingCompanyId = exhibiting_company_id;
      this.interviewScheduleId = interview_schedule_id;
      this.interviewStatus = interview_status;
    },
    handleCloseConfirmationCancel() {
      this.confirmationCancel = false;
      this.exhibitingCompanyId = null;
      this.interviewScheduleId = null;
      this.interviewStatus = null;
    },

    async applyOrCancelInterview() {
      if (
        this.exhibitingCompanyId !== null &&
        this.interviewScheduleId !== null &&
        this.interviewStatus !== null
      ) {
        this.btnLoading = true;
        const exhibiting_company_id = this.exhibitingCompanyId;
        const interview_schedule_id = this.interviewScheduleId;
        const interview_status = this.interviewStatus;

        if (this.interviewStatus === 0) {
          document.getElementById('btnCloseApplyConfirm').disabled = true;
        } else {
          document.getElementById('btnCloseCancelConfirm').disabled = true;
        }

        this.$store.dispatch('applyOrCancelInterview', {
          exhibiting_company_id,
          interview_schedule_id,
          interview_status
        });
      }
    },
    checkInterviewSchedule() {
      if (this.m_event.interview_function == DISPLAY_INTERVIEW_SCHEDULE) {
        return true;
      } else if (
        this.m_event.interview_function == UNDISPLAY_INTERVIEW_SCHEDULE
      ) {
        return false;
      }
    }
  },

  created() {
    this.currentRoute = this.$route.name;
    this.checkRoute();
    const { query, params } = this.$route;

    // Check preview company or detail company to call action
    if (typeof query.token !== 'undefined') {
      this.detailStatus = false;
      this.$store.dispatch('previewCompany', {
        company_token: query.token
      });
    } else {
      this.$store.dispatch('getCompanies');
      this.$store.dispatch('getEventInterviewNote');
      this.$store.dispatch('getCompanies');
      this.$store.dispatch('companyDetail', {
        exhibiting_company_id: params.companyID
      });
      this.$store.dispatch('applicantCompanyInterview', {
        exhibiting_company_id: params.companyID
      });
    }
  },

  watch: {
    companyDetail: function (val, oldVal) {
      if (val !== oldVal) {
        const { companyInfo } = val;

        if (typeof companyInfo != 'undefined' && companyInfo !== null) {
          const filtered =
            typeof this.favoriteCompany !== 'undefined'
              ? this.favoriteCompany.filter((ele) => ele.id === companyInfo.id)
              : [];

          if (filtered.length > 0) {
            this.favoriteStatus = true;
          } else {
            this.favoriteStatus = false;
          }
        }
      }
    },

    favoriteCompany: function (val, oldVal) {
      if (val !== oldVal && this.companyDetail !== null) {
        const { companyInfo } = this.companyDetail;

        if (typeof companyInfo != 'undefined' && companyInfo !== null) {
          const filtered = val.filter((ele) => ele.id === companyInfo.id);

          if (filtered.length > 0) {
            this.favoriteStatus = true;
          } else {
            this.favoriteStatus = false;
          }
        }
      }
    },

    '$i18n.locale': function () {
      return (this.headers = [
        {
          text: this.$t('company-detail.header-table.date', {
            split: '/'
          }),
          sortable: false,
          value: 'date'
        },
        {
          text: this.$t('company-detail.header-table.time', {
            split: '/'
          }),
          value: 'time'
        },
        {
          text: this.$t('company-detail.header-table.applicant_sum', {
            split: '/'
          }),
          sortable: false,
          value: 'applicant_sum'
        },
        {
          text: this.$t('company-detail.header-table.status', {
            split: '/'
          }),
          value: 'status'
        },
        {
          text: this.$t('company-detail.header-table.detail', {
            split: '/'
          }),
          value: 'button'
        }
      ]);
    },
    previewCompanyStatus: function (val) {
      return (this.viewPage = val);
    },
    applicantCompanyInterview: function (val) {
      this.btnLoading = false;
      if (this.interviewStatus === 0) {
        document.getElementById('btnCloseApplyConfirm').disabled = false;
        this.handleCloseConfirmationApply();
      }
      if (this.interviewStatus === 9) {
        document.getElementById('btnCloseCancelConfirm').disabled = false;
        this.handleCloseConfirmationCancel();
      }
      return val;
    }
  },

  computed: {
    ...mapGetters({
      companyDetail: 'getCompanyDetail',
      companyInterviewNote: 'getCompanyInterviewNote',
      previewCompanyStatus: 'getPreviewCompanyStatus',
      dataJobDescription: 'getJobDescriptionFromDetail',
      dataCompanyCareerFromDetail: 'getCompanyCareerFromDetail',
      dataCompanyPrFromDetail: 'getCompanyPrFromDetail',
      favoriteCompany: 'getFavoriteCompanyData',
      applicantCompanyInterview: 'getApplicantCompanyInterview',
      eventInterviewNote: 'getEventInterviewNote',
      companyInfoDetail: 'getCompanyInfoDetail'
    }),
    checkListCompanyDisplay: function () {
      if (this.m_event !== null) {
        const {
          company_publicizing_period_from,
          company_publicizing_period_to
        } = this.m_event;
        if (
          company_publicizing_period_from !== null &&
          company_publicizing_period_to !== null
        ) {
          return this.checkDisplayListCompany(
            company_publicizing_period_from,
            company_publicizing_period_to
          );
        }
      }
      return false;
    }
  }
};
</script>

<style lang="scss">
@import '@/style/common.scss';
@import './company.scss';
</style>
